import React, { createContext, useContext } from "react"
import {
    SessionsTableColumnsType,
    ExportFilterSession,
    IFormFilterSession,
    SessionInfo,
} from "types/sessions"
import { SortOrder } from "types/sort"
import { SubmitHandler } from "react-hook-form"

interface SessionsContextType {
    apiSuccess: boolean | null
    listSessions: SessionInfo[]
    fetchSessions: RequestFunction
    isLoading: boolean
    filteredSessions: SessionInfo[]
    sortedSessions: SessionInfo[]
    currentSessionsRows: SessionInfo[]
    sortOrder: SortOrder
    orderBy: keyof SessionsTableColumnsType
    setSortOrder: React.Dispatch<React.SetStateAction<SortOrder>>
    setOrderBy: React.Dispatch<
        React.SetStateAction<keyof SessionsTableColumnsType>
    >
    pageNumber: number
    numberOfPages: number
    handleChangePage: (_event: React.ChangeEvent<unknown>, page: number) => void
    onFilterSubmit: SubmitHandler<IFormFilterSession>
    defaultFilterValues: IFormFilterSession
    filterValues: IFormFilterSession | null
    noResultFilter: boolean
    setExportFilterSession: React.Dispatch<
        React.SetStateAction<ExportFilterSession | null>
    >
}

export const SessionsPageContext = createContext<
    SessionsContextType | undefined
>(undefined)

export const useSessionsContext = () => {
    const context = useContext(SessionsPageContext)
    if (context === undefined) {
        throw new Error(
            "useSessionsContext doit être utilisé à l'intérieur de SessionsPageProvider"
        )
    }
    return context
}
